import { render, staticRenderFns } from "./DashboardFamilyPP.vue?vue&type=template&id=f682b976&"
import script from "./DashboardFamilyPP.vue?vue&type=script&lang=js&"
export * from "./DashboardFamilyPP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports